import { serialize } from "object-to-formdata";
import { IAddPublicationShipmentRequest } from "../../../model/publication-shipment/request/add-publication-shipment-request";
import HttpClient from "../../services/http-client";
import { FileBase64Response } from "../../../model/base/response/file-base-64-response";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import { IListPublicationShipmentPagedRequest } from "../../../model/publication-shipment/request/list-publication-shipment-paged-request";
import { IPublicationShipmentResponse } from "../../../model/publication-shipment/response/publication-shipment-response";
import { ISubmissionPublicationFileResponse } from "../../../model/publication-shipment/response/submissin-publication-file-response";
import { IUserSendPublicationShipmentResponse } from "../../../model/publication-shipment/response/user-send-publication-shipment-response";
import { IListUsersSendpPublicationShipmentRequest } from "../../../model/publication-shipment/request/list-users-publication-shipment-request";
import { IPublicationShipmentStatusResponse } from "../../../model/publication-shipment/response/publication-shipment-status-response";
import { IDetailPublicationShipmentResponse } from "../../../model/publication-shipment/response/detail-publication-shipment-response";
import { IPublishingVehicleResponse } from "../../../model/publication-shipment/response/publising-vehicle-response";
import { IDashbboardResponse } from "../../../model/publication-shipment/response/dashboard-response";
import ApplicationAppService from "../application-app-service";
import { IUpdatePublicationShipmentRequest } from "../../../model/publication-shipment/request/update-publication-shipment-request";

const defaultPath = 'PublicationShipment';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.publicationShipmentUrl;

const addPublicationShipmentRequest = async (params: IAddPublicationShipmentRequest, files: File[]) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });


    files.forEach(file => {
        formData.append("files", file);
    });

    await HttpClient.executeRequest({
        method: 'post',
        data: formData,
        baseURL: baseUrl,
        url: `/${defaultPath}/Add`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const listUsersSend = async (params: IListUsersSendpPublicationShipmentRequest): Promise<IUserSendPublicationShipmentResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/UsersSend`,
        params: params
    }).then((response) => Object.assign([] as IUserSendPublicationShipmentResponse[], response.data));
};
const listStatus = async (): Promise<IPublicationShipmentStatusResponse[]> => {
    return await
        HttpClient.executeRequest({
            method: 'get',
            baseURL: baseUrl,
            url: `/${defaultPath}/Status`
        }).then((response) => Object.assign([] as IPublicationShipmentStatusResponse[], response.data));
};
const listPublishingVehicle = async (): Promise<IPublishingVehicleResponse[]> => {
    return await
        HttpClient.executeRequest({
            method: 'get',
            baseURL: baseUrl,
            url: `/${defaultPath}/PublishingVehicle`
        }).then((response) => Object.assign([] as IPublishingVehicleResponse[], response.data));
};

const getDashboard = async (): Promise<IDashbboardResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Dashboard`
    }).then((response) => Object.assign({} as IDashbboardResponse, response.data));
};
const list = async (params: IListPublicationShipmentPagedRequest): Promise<PaginationResponse<IPublicationShipmentResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/list`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IPublicationShipmentResponse>(), response.data));
};

const getById = async (id: number): Promise<IDetailPublicationShipmentResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}`
    }).then((response) => Object.assign({} as IDetailPublicationShipmentResponse, response.data));
};


const listFiles = async (id: number): Promise<ISubmissionPublicationFileResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}/Files`
    }).then((response) => Object.assign([] as unknown as ISubmissionPublicationFileResponse, response.data));
};


const downloadFiles = async (id?: number): Promise<FileBase64Response> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}/Files/Download`
    }).then((response) => Object.assign(new FileBase64Response(), response.data));
};

const downloadFilesBase64 = async (id?: number): Promise<FileBase64Response[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}/Files/Base64`
    }).then((response) => Object.assign([] as unknown as FileBase64Response, response.data));
};


const downloadFile = async (id: number, idFile: number): Promise<FileBase64Response> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/${id}/File/Download/${idFile}`
    }).then((response) => Object.assign(new FileBase64Response(), response.data));
};
const update = async (content: IUpdatePublicationShipmentRequest) => {
    await HttpClient.executeRequest({
        method: 'put',
        baseURL: baseUrl,
        url: `/${defaultPath}/${content.id}`,
        data: content
    });
};


const PublicationShipmentAppService = {
    addPublicationShipmentRequest,downloadFilesBase64, update, list, getDashboard, getById, downloadFile, downloadFiles, listFiles, listStatus, listUsersSend, listPublishingVehicle
}

export default PublicationShipmentAppService;